export default __webpack_public_path__ + "static/how-to-pick-the-right-credit-card-for-your-travel-bridge-ce80fff4b3d02ea4739c11e467541e3d.jpg";